import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";

import {UserInfo} from "../interface/user-info.interface";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MotoAiRegistrationService {

  private baseUrl = environment.apiUrl;
  private motoAiBetaCampaign = environment.campaignName.motoAiBeta
  private apiKey = environment.apiKey;

  constructor(private http: HttpClient) {
  }

  subscribeUser(userInfo: UserInfo, systemLanguage: string) {
    const url = `${this.baseUrl}/${this.motoAiBetaCampaign}`;

    const headers: HttpHeaders = this.setupHeaders();

    const body = {
      name: userInfo.name,
      email: userInfo.email,
      systemLanguage,
      isRequirementsConfirmed: userInfo.isRequirementsConfirmed
    };

    return this.http.post<any>(url, body, {headers: headers});
  }

  unsubscribeUser(userRef: string, campaignName: string) {
    const url = `${this.baseUrl}/${campaignName}/unsubscribe/${userRef}`;

    const headers: HttpHeaders = this.setupHeaders();


    return this.http.delete<any>(url, {headers: headers});
  }

  private setupHeaders() {
    const headers: HttpHeaders = new HttpHeaders().set('Authorization',  this.apiKey);

    headers.set("Access-Control-Allow-Origin", "*");
    headers.set("Access-Control-Allow-Headers", "*");
    headers.set("Access-Control-Allow-Methods", "GET, POST, PUT, DELETE, PATCH, OPTIONS");

    return headers;
  }
}
